import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ExamenResultatModel } from '../models/examen-resultat.model';
import { FormGeneratorService } from '@ngx-resource-toolkit/core';
import { BulletinService } from '../../services/bulletin.service';
import { HttpClient } from '@angular/common/http';
import { ToasterService } from 'angular2-toaster';

@Component({
    selector: 'app-evaluation',
    templateUrl: './evaluation.component.html',
    styleUrls: ['./evaluation.component.scss']
})
export class EvaluationComponent implements OnInit, OnDestroy, OnChanges {

    // @Input() formEval: FormGroup;
    public formEval: FormGroup;
    @Input() resultatExamen: ExamenResultatModel;
    @Input() mode: string = 'consult';
    @Input() examen: any;
    @Input() indiceEval: number; // indice de l'évaluation en cours (indice dans la liste du parent)
    @Input() isBoutonEditionActif: boolean = false;
    @Input() isDispenseAutorise: boolean = false;
    @Input() isJuryLectureAutorisee: boolean = false;

    @Output() editEvt: EventEmitter<{resultat: ExamenResultatModel, examen: any, indiceEval: number}> = new EventEmitter<{resultat: ExamenResultatModel, examen: any, indiceEval: number}>();
    @Output() canceled: EventEmitter<any> = new EventEmitter();
    @Output() saved: EventEmitter<any> = new EventEmitter<any>();

    private subData; // data du subscribe pour le unsubscribe

    constructor(
        // private formBuilder: FormBuilder, // pour utilisation angular pur
        private formGenerator: FormGeneratorService, // pour utilisation ngix
        private bulletinService: BulletinService,
        private http: HttpClient,
        private toaster: ToasterService,
    ) { }

    ngOnInit(): void {
        console.log('evaluation.component.ngOnInit');
        // TODO : Rechercher si l'utilisateur a les droits pour cocher Dispensé
        // isModificationDispenseAutorisee = this.isModificationAutorisee && FonctionnaliteHelper.isLectureAutorisee('EXAMEN_DISPENSE'); => permet d'activer ou non la case à cocher (pas besoin d'être en édition pour la cocher. si case cochée => masquer le reste du bulletin)
		// isJuryLectureAutorisee = examen.juryMention!=0 && FonctionnaliteHelper.isLectureAutorisee('EXAMEN_JURY'); => indique s'il faut afficher ou masquer les données concernant le jury
    }
    ngOnChanges(changes: SimpleChanges): void {
        // console.log({ ou: 'ngOnChanges', changes, mode: this.mode });
        if (changes['resultatExamen']) {
            // console.log(this.isDispenseAutorise);
            this.resultatExamen.setIsDispenseAutorise(this.isDispenseAutorise);
            this.formEval = this.formGenerator.createFormGroup(this.resultatExamen, this.mode);
            /*this.resultatExamen.registerEntryDynamicProperty([this.mode], 'isDispense', 'options', [{
                label: '',
                // value: true,
                disabled: this.isDispenseAutorise,
            }]);*/
        }
    }
    ngOnDestroy(): void {
        console.log('ngOnDestroy');
        // throw new Error("Method not implemented.");
        if (this.subData) {
            this.subData.unsubscribe();
        }
    }
    edit() {
        console.log('edit', this.resultatExamen);
        //Recherche des données sur le serveur : pour avoir les dernières données avec la liste des mentions possibles pour chaque zone de saisie.
        const anneeScolaire = this.resultatExamen.anneeScolaire;

        /*Observable.forkJoin(
            this.bulletinService.getExamenResultatComplet(
                this.resultatExamen.idExamen,
                this.resultatExamen.idEleve,
                this.resultatExamen.idDiscipline,
                this.resultatExamen.idCycle,
                this.resultatExamen.idNiveau,
                anneeScolaire),
            Observable.from([this.examen])
        )
        .subscribe(data => {
            const [resultNew, examen] = data;
            console.log('forkJoin', resultNew, examen, this.examen);
        });*/

        // console.log('edit anneeScolaire=', anneeScolaire, this.resultatExamen);
        this.subData = this.bulletinService.getExamenResultatComplet(
            this.resultatExamen.idExamen,
            this.resultatExamen.idEleve,
            this.resultatExamen.idDiscipline,
            this.resultatExamen.idCycle,
            this.resultatExamen.idNiveau,
            anneeScolaire)
            .subscribe(data => {
                console.log({ data, examen: data['examen'], typeNotation: data['examen']['typeNotation'] });
                data['idCycle'] = this.resultatExamen.idCycle;
                data['idNiveau'] = this.resultatExamen.idNiveau;
                data['anneeScolaire'] = anneeScolaire;
                data['idEleve'] = this.resultatExamen.idEleve;
                data['idDiscipline'] = this.resultatExamen.idDiscipline;
                const examen = null;
                const typeNotation = null;
                const isInitModele = true;
                const isInitData = true;
                const isHistorique = false;
                const isDispenseAutorise = this.isDispenseAutorise;
                const isJuryLectureAutorisee = this.isJuryLectureAutorisee;
                const examResultat = new ExamenResultatModel(data, examen, typeNotation, isInitModele,
                    isInitData, isHistorique, isDispenseAutorise, isJuryLectureAutorisee);
                // Répercution des droits sur dispensé et jury : int"gré dans le constructeur ci-dessus
                // examResultat.setIsDispenseAutorise(this.isDispenseAutorise);
                // examResultat.setIsJuryVisible(this.isJuryLectureAutorisee);

                console.log('edit', examResultat, this.examen);
                this.editEvt.emit({
                    resultat: examResultat,
                    examen: this.examen,
                    indiceEval: this.indiceEval,
                });
                // this.bulletin.resultatsExamens[this.indiceExamEnCoursEdition] = new ExamenResultatModel(resultatExamenEleveCourant);
                // this.bulletinForm.value[i] = this.formGenerator.createFormGroup(this.bulletin.resultatsExamens[this.indiceExamEnCoursEdition], 'edit');

            });

        // this.modalEdit.open();

    }

    save() {
        console.log('save eval', this.resultatExamen);
        // TODO enregistrer uniquement si données validées (pas d'erreur de données)
        if (this.formEval.invalid) {
            this.toaster.pop('error', 'Des erreurs ont été détectées. Veuillez corriger votre saisie.');
            return;
        }
        if (this.formEval.value) {
            if (this.formEval.value.note_1 == "") {
                this.formEval.value.note_1 = null;
            }
            if (this.formEval.value.note_2 == "") {
                this.formEval.value.note_2 = null;
            }
            if (this.formEval.value.note_3 == "") {
                this.formEval.value.note_3 = null;
            }
            if (this.formEval.value.note_4 == "") {
                this.formEval.value.note_4 = null;
            }
            if (this.formEval.value.note_5 == "") {
                this.formEval.value.note_5 = null;
            }
            if (this.formEval.value.note_6 == "") {
                this.formEval.value.note_6 = null;
            }
            if (this.formEval.value.note_7 == "") {
                this.formEval.value.note_7 = null;
            }
            if (this.formEval.value.note_8 == "") {
                this.formEval.value.note_8 = null;
            }
        }

        console.log(this.formEval);
        // Les données suivantes doivent être présentes :
        // anneeScolaire, idEleve, idDiscipline, idCycle, idNiveau, idCursus, idCycle, idNiveau, idExamen, idTypeNotation
        // ServiceExamen.saveResultatExamen(this.resultatExamen)
        // let form = this.formGenerator.createFormGroup(this.resultatExamen, 'edit');
        console.log('form avant enregistrement', this.formEval);
        new ExamenResultatModel().getResource('default', 'post')
            .call(this.http, 'saveResultatExamen', this.formEval)
            .subscribe(data => {
                console.log('data', data);
                /*this.examens = this.examens.map(row => {
                    return (row.id === event.row.id
                            && row.idDiscipline === event.row.idDiscipline
                            && row.idEleve === event.row.idEleve
                            && row.anneeScolaire === event.row.anneeScolaire)
                        ? newRow
                        : row;
                });*/

                this.toaster.pop('success', 'L\'évaluation a été enregistrée');
                this.saved.emit(data);
            }, err => {
                console.log('error lors de l\'enregistrement de l\'évaluation', err);
                this.toaster.pop('error', 'L\'enregistrement de l\'évaluation a échoué');
            })
    }
    cancel() {
        console.log('Annuler');
        this.canceled.emit();
    }


    public process(): void {
        console.log('process', this.formEval.value);
    }

    public isError(chp: string): boolean {
        return this.formEval.get(chp).invalid && this.formEval.get(chp).touched;
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/examen/evaluation/evaluation.component.ts